import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-510b12dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full overflow-y-auto content-box max-w-14xl" }
const _hoisted_2 = { class: "flex-shrink-0 profile-card" }
const _hoisted_3 = {
  key: 0,
  class: "btn-section"
}
const _hoisted_4 = {
  key: 1,
  class: "blank-box"
}
const _hoisted_5 = { class: "info-box" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info-section" }
const _hoisted_8 = { class: "user-name text-gray-600" }
const _hoisted_9 = {
  key: 0,
  class: "follow-btn bg-primary"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600" }, " ＋ 关注 ", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "bio text-gray-500" }
const _hoisted_13 = {
  key: 2,
  class: "follow-box"
}
const _hoisted_14 = { class: "follow-section" }
const _hoisted_15 = { class: "follow-number text-gray-600" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "follow-text text-gray-500" }, " 关注 ", -1))
const _hoisted_17 = { class: "follow-section" }
const _hoisted_18 = { class: "follow-number text-gray-600" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "follow-text text-gray-500" }, " 粉丝 ", -1))
const _hoisted_20 = { class: "follow-section" }
const _hoisted_21 = { class: "follow-number text-gray-600" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "follow-text text-gray-500" }, " 被收藏数 ", -1))
const _hoisted_23 = { class: "flex-auto h-0 bg-white rounded-lg shadow-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_badge = _resolveComponent("f-badge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_rating_list = _resolveComponent("rating-list")!
  const _component_f_tab_pane = _resolveComponent("f-tab-pane")!
  const _component_comment_list = _resolveComponent("comment-list")!
  const _component_lesson_list = _resolveComponent("lesson-list")!
  const _component_common_list = _resolveComponent("common-list")!
  const _component_f_tabs = _resolveComponent("f-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isCurrentUser())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "control-btn",
              to: "/about",
              title: "关于我们"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_f_badge, {
                  visible: _ctx.isAboutBadgeVisible,
                  "offset-x": "0.5",
                  "offset-y": "0.5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_f_icon, {
                      class: "text-gray-500",
                      name: "question-circle"
                    })
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "control-btn",
              to: "/user/edit",
              title: "编辑资料"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_f_icon, {
                  class: "text-gray-500",
                  name: "pencil-square"
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              class: "control-btn",
              title: "退出登录",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, [
              _createVNode(_component_f_icon, {
                class: "text-gray-500",
                name: "door-open"
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          class: "flex-shrink-0 avatar border-2 border-primary",
          src: _ctx.processAvatar(_ctx.userProfile.avatar),
          alt: "avatar"
        }, null, 8, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.userProfile.nickname || _ctx.userProfile.name), 1),
            (!_ctx.isCurrentUser())
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.userProfile.bio || ''), 1)
        ])
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.userProfile.watchers || 0), 1),
              _hoisted_16
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.userProfile.watchees || 0), 1),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.userProfile.fans || 0), 1),
              _hoisted_22
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_component_f_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
        class: "w-full h-full"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_f_tab_pane, { tab: "点评" }, {
            default: _withCtx(() => [
              _createVNode(_component_rating_list, {
                active: _ctx.activeTab === '点评'
              }, null, 8, ["active"])
            ]),
            _: 1
          }),
          false
            ? (_openBlock(), _createBlock(_component_f_tab_pane, {
                key: 0,
                tab: "回复"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_comment_list, {
                    active: _ctx.activeTab === '回复'
                  }, null, 8, ["active"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_f_tab_pane, { tab: "课程" }, {
            default: _withCtx(() => [
              _createVNode(_component_lesson_list, {
                active: _ctx.activeTab === '课程'
              }, null, 8, ["active"])
            ]),
            _: 1
          }),
          false
            ? (_openBlock(), _createBlock(_component_f_tab_pane, {
                key: 1,
                tab: "收藏"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_common_list, {
                    active: _ctx.activeTab === '收藏',
                    type: "收藏"
                  }, null, 8, ["active"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isCurrentUser() && false)
            ? (_openBlock(), _createBlock(_component_f_tab_pane, {
                key: 2,
                tab: "关注"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_common_list, {
                    active: _ctx.activeTab === '关注',
                    type: "关注"
                  }, null, 8, ["active"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isCurrentUser() && false)
            ? (_openBlock(), _createBlock(_component_f_tab_pane, {
                key: 3,
                tab: "足迹"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_common_list, {
                    active: _ctx.activeTab === '足迹',
                    type: "足迹"
                  }, null, 8, ["active"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}